/* LP2 live Morse preview (B3 Polaroid tag), 10/16/2026. Built by Opilio Claudio.
 The word in Morse on a Polaroid card in a teal strip under the Your Word box; a pink notice
 for characters the Morse can't show (only a-z, 0-9, & and + are drawn). Read only: writes no
 input, form, property or cart, no preventDefault. Any error removes it and changes nothing.
 TO TURN OFF: delete the LP2 block (item 16) at the end of snippets/kd-lg1-fonts.liquid. */
(function () {
 'use strict';
 if (window.kdLp2) return;
 window.kdLp2 = { v: 1 };
 var dead = false, mo = null, raf = 0, tmo = 0, wide = [];
 var SEL = 'input[data-kd-field="word"]';
 var CH = String.fromCharCode;
 var MARKS = new RegExp('[' + CH(0x300) + '-' + CH(0x36f) + ']', 'g');
 var T = { a: '.-', b: '-...', c: '-.-.', d: '-..', e: '.', f: '..-.', g: '--.', h: '....', i: '..', j: '.---', k: '-.-', l: '.-..', m: '--', n: '-.', o: '---', p: '.--.', q: '--.-', r: '.-.', s: '...', t: '-', u: '..-', v: '...-', w: '.--', x: '-..-', y: '-.--', z: '--..',
  '0': '-----', '1': '.----', '2': '..---', '3': '...--', '4': '....-', '5': '.....', '6': '-....', '7': '--...', '8': '---..', '9': '----.', '&': '.-...', '+': '.-.-.' };
 var W = '.kd-opts input.kd-lp2-in[data-kd-field="word"]';
 var M = 'font-family:Montserrat,sans-serif;letter-spacing:0;text-transform:none;';
 var CSS = [
  W + '{text-align:center!important;font-family:Marcellus,serif!important;font-size:var(--kd-lp2-fs,17px)!important;font-weight:400!important;text-transform:none!important;font-variant:normal!important;-webkit-text-stroke:.3px currentColor;letter-spacing:.2em!important;text-indent:.2em!important;border-bottom-color:transparent!important;border-bottom-left-radius:0!important;border-bottom-right-radius:0!important}',
  W + ':placeholder-shown{text-indent:0!important;letter-spacing:0!important;-webkit-text-stroke:0}',
  W + '::placeholder{font-size:16px;font-weight:400;letter-spacing:0;text-align:center}',
  '.kd-lp2{display:block;box-sizing:border-box;width:100%;margin:0;padding:12px 14px 14px;background:#233F45;border-top:0}',
  '.kd-lp2__card{box-sizing:border-box;margin:0;padding:8px 8px 0;background:#FCFBFA;border:1px solid #D8D0CB;box-shadow:0 2px 6px rgba(0,0,0,.28)}',
  '.kd-lp2__win{box-sizing:border-box;cursor:default;display:flex;align-items:center;justify-content:center;min-height:72px;padding:12px 10px;background:#EFEBE9}',
  '.kd-lp2__code{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;row-gap:9px}',
  '.kd-lp2:not(.is-typed) .kd-lp2__code,.kd-lp2.is-typed .kd-lp2__hint{display:none}',
  '.kd-lp2__hint{' + M + 'font-size:12px;font-weight:400;line-height:16px;color:#5E6A6C;-webkit-text-fill-color:#5E6A6C}',
  '.kd-lp2__l,.kd-lp2__g{display:flex;align-items:center;height:12px}',
  '.kd-lp2__l{gap:3.5px}.kd-lp2__g{gap:3px;margin:0 5px}',
  '.kd-lp2__d,.kd-lp2__h,.kd-lp2__s{display:block;flex:none;box-sizing:border-box}',
  '.kd-lp2__d{width:3.5px;height:3.5px;border-radius:50%;background:#233F45}',
  '.kd-lp2__h{width:8.75px;height:2.2px;border-radius:1.1px;background:#233F45}',
  '.kd-lp2__s{width:1.5px;height:10px;border-radius:1px;background:#A3A8AF}',
  '.kd-lp2--gold .kd-lp2__s{background:#B49A5E}.kd-lp2--rose .kd-lp2__s{background:#C4918E}',
  '.kd-lp2--hoops .kd-lp2__s{width:7px;height:7px;border-radius:50%;background:transparent;border:1px solid #858A93}',
  '.kd-lp2__band{display:flex;align-items:center;justify-content:center;height:34px;font-family:Sacramento,cursive;font-size:23px;font-weight:400;line-height:1;letter-spacing:0;text-transform:lowercase;color:#B4507A;-webkit-text-fill-color:#B4507A;-webkit-text-stroke:.35px #B4507A}',
  '.kd-lp2-note{display:flex;align-items:flex-start;gap:10px;box-sizing:border-box;margin:12px 0 0;padding:10px 12px;border:1.5px solid #9D4861;background:#FBE7EB;' + M + 'font-size:14px;font-weight:400;line-height:20px;text-align:left;color:#4A1A2B;-webkit-text-fill-color:#4A1A2B;animation:kdLp2In .35s ease-out both}',
  '.kd-lp2-note[hidden]{display:none!important}',
  '.kd-lp2-note__i{flex:none;width:20px;height:20px;border-radius:50%;background:#9D4861;' + M + 'font-size:13px;font-weight:700;line-height:20px;text-align:center;color:#fff;-webkit-text-fill-color:#fff}',
  '.kd-lp2-note__h{font-weight:600}',
  '.kd-lp2-note__c{display:inline-block;padding:0 6px;border:1px solid #9D4861;border-radius:4px;background:#fff;font-weight:600;line-height:18px}',
  '@keyframes kdLp2In{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:none}}',
  '@media (prefers-reduced-motion:reduce){.kd-lp2-note{animation:none}}'
 ].join('');

 function kill() {
  dead = true;
  try { if (mo) mo.disconnect(); } catch (e) {}
  try {
   var a = document.querySelectorAll('.kd-lp2,.kd-lp2-note,#kd-lp2-css'), i;
   for (i = 0; i < a.length; i++) if (a[i].parentNode) a[i].parentNode.removeChild(a[i]);
   a = document.querySelectorAll('.kd-lp2-in');
   for (i = 0; i < a.length; i++) { a[i].classList.remove('kd-lp2-in'); if (a[i].parentNode) a[i].parentNode.style.removeProperty('--kd-lp2-fs'); }
   for (i = 0; i < wide.length; i++) unfit(wide[i]);
  } catch (e) {}
 }
 function safe(fn) {
  return function () { if (dead) return; try { fn.apply(this, arguments); } catch (e) { kill(); } };
 }
 function mk(tag, cls, txt) {
  var e = document.createElement(tag);
  if (cls) e.className = cls;
  if (txt) e.textContent = txt;
  return e;
 }
 function setup() {
  if (!document.getElementById('kd-lp2-css')) {
   var s = mk('style'); s.id = 'kd-lp2-css'; s.textContent = CSS;
   (document.head || document.documentElement).appendChild(s);
  }
  var has = false;
  try { document.fonts.forEach(function (f) { if (/sacramento/i.test(f.family)) has = true; }); } catch (e) {}
  if (!has && !document.getElementById('kd-lp2-font')) {
   var l = mk('link'); l.id = 'kd-lp2-font'; l.rel = 'stylesheet';
   l.href = 'https://fonts.googleapis.com/css2?family=Sacramento&text=in%20morse&display=swap';
   (document.head || document.documentElement).appendChild(l);
  }
 }
 function build(inp) {
  var st = { inp: inp, key: null, bk: '' };
  st.strip = mk('div', 'kd-lp2');
  st.strip.setAttribute('aria-hidden', 'true');
  var card = mk('div', 'kd-lp2__card'), win = mk('div', 'kd-lp2__win');
  st.code = mk('div', 'kd-lp2__code');
  win.appendChild(st.code);
  win.appendChild(mk('span', 'kd-lp2__hint', 'Type above to see it in Morse'));
  card.appendChild(win);
  card.appendChild(mk('div', 'kd-lp2__band', 'in morse'));
  st.strip.appendChild(card);
  st.note = mk('div', 'kd-lp2-note');
  st.note.setAttribute('aria-live', 'polite');
  st.note.hidden = true;
  inp.classList.add('kd-lp2-in');
  inp.addEventListener('input', sched);
  inp._kdLp2 = st;
  return st;
 }
 function metal(inp) {
  var sc = inp.closest('product-info') || document, v = '', i;
  var sp = sc.querySelector('[data-kd-sp1]');
  if (sp) {
   var tk = sp.querySelector('[data-kd-sp1-tick]'), op = sp.querySelector('[data-kd-sp1-opt]:checked');
   if (tk && tk.checked && op) v = op.value || 'rose';
  }
  if (!v) {
   var a = sc.querySelectorAll('variant-selects [data-popout-input], variant-selects select, variant-selects input[type="radio"]:checked');
   for (i = 0; i < a.length; i++) if (/spacer/i.test(a[i].getAttribute('name') || '')) { v = a[i].value || ''; break; }
  }
  v = String(v).toLowerCase();
  if (v.indexOf('hoop') > -1) return 'hoops';
  if (v.indexOf('rose') > -1) return 'rose';
  if (v.indexOf('gold') > -1) return 'gold';
  if (v.indexOf('silver') > -1) return 'silver';
  var d = String(window.kdLp2Spacer || '');
  return /^(rose|gold|silver|hoops)$/.test(d) ? d : 'silver';
 }
 function render(st, m) {
  var w = String(st.inp.value || ''), key = w + '|' + m;
  if (key === st.key) return;
  st.key = key;
  var code = st.code, chars = Array.from ? Array.from(w) : w.split(''), bad = [], had = false, gap = false, n = 0, i, k;
  var frag = document.createDocumentFragment();
  for (i = 0; i < chars.length; i++) {
   var ch = chars[i];
   if (ch.trim() === '') { if (had) gap = true; continue; }
   var f = ch.toLowerCase();
   if (f.normalize) f = f.normalize('NFD').replace(MARKS, '');
   var c = T[f];
   if (!c) { if (bad.indexOf(ch) < 0) bad.push(ch); continue; }
   if (had) {
    var g = mk('span', 'kd-lp2__g');
    g.appendChild(mk('span', 'kd-lp2__s'));
    if (gap) g.appendChild(mk('span', 'kd-lp2__s'));
    frag.appendChild(g);
   }
   var L = mk('span', 'kd-lp2__l');
   for (k = 0; k < c.length; k++) L.appendChild(mk('span', c.charAt(k) === '.' ? 'kd-lp2__d' : 'kd-lp2__h'));
   frag.appendChild(L);
   had = true; gap = false; n++;
  }
  while (code.firstChild) code.removeChild(code.firstChild);
  code.appendChild(frag);
  st.strip.className = 'kd-lp2 kd-lp2--' + m + (n ? ' is-typed' : '');
  var note = st.note;
  if (!bad.length) { if (!note.hidden) note.hidden = true; st.badKey = ''; return; }
  var bk = bad.join(' ');
  if (bk === st.badKey && !note.hidden) return;
  st.badKey = bk;
  while (note.firstChild) note.removeChild(note.firstChild);
  var ic = mk('span', 'kd-lp2-note__i', '!'); ic.setAttribute('aria-hidden', 'true');
  note.appendChild(ic);
  var tx = mk('span');
  tx.appendChild(mk('span', 'kd-lp2-note__h', 'Heads up:'));
  tx.appendChild(document.createTextNode(' we can add '));
  for (i = 0; i < bad.length; i++) {
   if (i) tx.appendChild(document.createTextNode(i === bad.length - 1 ? ' and ' : ', '));
   tx.appendChild(mk('span', 'kd-lp2-note__c', bad[i]));
  }
  tx.appendChild(document.createTextNode(' to your printed card, but not to the Morse itself.'));
  note.appendChild(tx);
  note.hidden = false;
 }
 function border(st) {
  var cs = getComputedStyle(st.inp), b = cs.borderLeftWidth + ' ' + cs.borderLeftStyle + ' ' + cs.borderLeftColor;
  var k = b + '|' + cs.borderTopLeftRadius + '|' + cs.borderTopRightRadius;
  if (k === st.bk) return;
  st.bk = k;
  var s = st.strip.style;
  s.borderLeft = b; s.borderRight = b; s.borderBottom = b;
  s.borderBottomLeftRadius = cs.borderTopLeftRadius;
  s.borderBottomRightRadius = cs.borderTopRightRadius;
 }
 function unfit(row) {
  var s = row.style;
  if (!s.getPropertyValue('--kd-lp2-w')) return;
  ['width', 'margin-left', 'position', 'z-index', '--kd-lp2-w'].forEach(function (p) { s.removeProperty(p); });
 }
 /* desktop: a word box in one cell of the two-across menu grid runs the full product column */
 function fit(row) {
  if (row.classList.contains('kd-wb1-float')) {
   var sc = row.closest('product-info') || document, sp = sc.querySelectorAll('.kd-wb1-spot'), spot = null, pf = row.parentNode;
   for (var k = 0; k < sp.length; k++) if (sp[k].getClientRects().length) spot = sp[k];
   if (spot && pf && !row.hidden) {
    var sb = spot.getBoundingClientRect(), pb = pf.getBoundingClientRect();
    if (pb.width - sb.width > 4) {
     var fw = Math.round(pb.width * 10) / 10 + 'px', fm = Math.round((pb.left - sb.left) * 10) / 10 + 'px', fs = row.style;
     if (fs.getPropertyValue('--kd-lp2-w') !== fw || fs.marginLeft !== fm) {
      fs.setProperty('--kd-lp2-w', fw);
      fs.setProperty('width', fw, 'important');
      fs.setProperty('margin-left', fm, 'important');
      if (wide.indexOf(row) < 0) wide.push(row);
     }
     return;
    }
   }
   unfit(row);
   return;
  }
  var cell = row.parentNode, vs = row.closest('variant-selects'), L = 1e9, R = -1e9;
  if (vs && cell && row.classList.contains('kd-wb1') && !row.hidden) {
   var pf = row.closest('.product__form'), a = pf ? [pf] : vs.querySelectorAll('.selector-wrapper');
   for (var i = 0; i < a.length; i++) {
    if (a[i] !== pf && a[i].closest('[data-kd-row]')) continue;
    var b = a[i].getBoundingClientRect();
    if (!b.width) continue;
    if (b.left < L) L = b.left;
    if (b.right > R) R = b.right;
   }
   var c = cell.getBoundingClientRect();
   if (R > L && R - L - c.width > 4) {
    var w = Math.round((R - L) * 10) / 10 + 'px', ml = Math.round((L - c.left) * 10) / 10 + 'px', s = row.style;
    if (s.getPropertyValue('--kd-lp2-w') !== w || s.marginLeft !== ml) {
     s.setProperty('--kd-lp2-w', w);
     s.setProperty('width', w, 'important');
     s.setProperty('margin-left', ml, 'important');
     s.setProperty('position', 'relative');
     s.setProperty('z-index', '1');
     if (wide.indexOf(row) < 0) wide.push(row);
    }
    return;
   }
  }
  unfit(row);
 }
 var cvs = null;
 /* the typed word starts at 17px and shrinks (down to 11px) so a long word fits the box */
 function size(inp) {
  var row = inp.parentNode, cs = getComputedStyle(inp), v = String(inp.value || ''), px = 17;
  var avail = inp.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) - 6;
  if (v && avail > 0) {
   cvs = cvs || document.createElement('canvas');
   var c = cvs.getContext('2d');
   c.font = '400 17px Marcellus, serif';
   var w = c.measureText(v).width + (Array.from ? Array.from(v).length : v.length) * 3.4;
   if (w > avail) px = Math.max(11, Math.floor(170 * avail / w) / 10);
  }
  px += 'px';
  if (row && row.style.getPropertyValue('--kd-lp2-fs') !== px) row.style.setProperty('--kd-lp2-fs', px);
 }
 var check = safe(function () {
  if (raf) cancelAnimationFrame(raf);
  clearTimeout(tmo);
  raf = 0;
  var a = document.querySelectorAll(SEL);
  for (var i = 0; i < a.length; i++) {
   var inp = a[i], st = inp._kdLp2 || build(inp), row = inp.parentNode;
   if (inp.nextElementSibling !== st.strip) inp.insertAdjacentElement('afterend', st.strip);
   if (row && st.note.parentNode !== row) row.appendChild(st.note);
   render(st, metal(inp));
   size(inp);
   border(st);
   if (row) fit(row);
  }
 });
 function sched() {
  if (dead || raf) return;
  raf = requestAnimationFrame(check);
  tmo = setTimeout(check, 120);
 }
 var start = safe(function () {
  setup();
  check();
  document.addEventListener('change', function (e) {
   var t = e.target;
   if (t && t.closest && (t.closest('[data-kd-sp1]') || /spacer/i.test(t.getAttribute('name') || ''))) sched();
  }, true);
  window.addEventListener('resize', sched);
  window.addEventListener('load', sched);
  try { document.fonts.ready.then(sched); } catch (e) {}
  if (window.MutationObserver) {
   mo = new MutationObserver(function (recs) {
    for (var i = 0; i < recs.length; i++) {
     var t = recs[i].target;
     if (!(t.closest && t.closest('.kd-lp2,.kd-lp2-note'))) { sched(); return; }
    }
   });
   mo.observe(document.body, { childList: true, subtree: true });
  }
 });
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
 else start();
})();
